import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 32 32",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 3,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "Copy link"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M13.3 17.3a6.7 6.7 0 0 0 10.1 0.7l4-4a6.7 6.7 0 0 0-9.4-9.4l-2.3 2.3" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.7 14.7a6.7 6.7 0 0 0-10.1-0.7l-4 4a6.7 6.7 0 0 0 9.4 9.4l2.3-2.3" })
	]
});
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
